import React, { useState, useEffect } from "react";
import {
  Get_All_Plans,
  AllGetPlanDetails,
  Get_All_Buyed_Plans,
  BuyPlan,
  BuyPlanNew,
  AddBalance,
  ExpirePlanDetails,
  applyCouponCode,
  GetUserBalence,
  Get_Profile_Data,
  AllUserPlanDetails,
} from "../../CommonAPI/User";
import Swal from "sweetalert2";
// import Tab from "react-bootstrap/Tab";
import Tabs from "@mui/material/Tabs";
import NewsTicker from "./Expair";
import Content from "../../../ExtraComponent/Content";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { Modal, Button, TextField, Stack, Typography } from "@mui/material";
import { getAddOnPlans } from "../../CommonAPI/Admin";
import Loader from "../../../ExtraComponent/Loader";
import {
  CalendarDays,
  FileText,
  LineChart,
  BadgePercent,
  Repeat2,
  ShoppingCart,
  Tags,
  CalendarClock,
  Signal,
  Layers3,
} from "lucide-react";
import { FaRupeeSign } from "react-icons/fa";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  padding: 5,
};

const ServicesList = () => {
  const username = localStorage.getItem("name");
  const PermissionGolden = localStorage.getItem("Permission");
  const adminPermission = localStorage.getItem("adminPermission");

  const [plansData, setPlansData] = useState({
    loading: true,
    data: [],
  });

  const [purchasedPlans, setPurchasedPlans] = useState([]);
  const expire = localStorage.getItem("expire");
  const [planExpired, setPlanExpired] = useState([]);
  const [expandedOptions, setExpandedOptions] = useState([]);
  const [expandedPatternItems, setExpandedPatternItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [verificationColor, setVerificationColor] = useState("");
  const [isContinueEnabled, setIsContinueEnabled] = useState(false);
  const [userBalance, setUserBalance] = useState(0);
  const [addOnPlans, setAddOnPlans] = useState([]);
  const [showSOPModal, setShowSOPModal] = useState(false);
  const [selectedSOPIndex, setSelectedSOPIndex] = useState(null);
  const [selectedAddOnPlan, setSelectedAddOnPlan] = useState(null);
  const [value, setValue] = useState(
    adminPermission?.includes("OverallPlan") ? "3" : "1"
  );
  const [getData, setData] = useState({});

  console.log("PermissionGolden", PermissionGolden.includes("Golden Strategy"));

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setVerificationMessage("");
    setVerificationColor("");
    setIsContinueEnabled(false);
  };

  useEffect(() => {
    const getProfileData = async () => {
      try {
        const requestData = { username };
        const response = await Get_Profile_Data(requestData);

        if (response.Status) {
          setData({ loading: false, profile: response?.Data[0] });
        } else {
          setData({ loading: false, profile: {} });
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
        setData({ loading: false, profile: {} });
      }
    };
    getProfileData();
  }, []);

  useEffect(() => {
    fetchPlans();
    fetchPurchasedPlans();
    isPlanExpired();
  }, []);

  useEffect(() => {
    fetchAddOnPlans();
  }, [value]);

  useEffect(() => {
    fetchBalance();
  }, [open]);

  const handleVerify = async () => {
    if (selectedPlan) {
      const planDetails = selectedPlan.isCharting
        ? getUpdatedPlansCharting[selectedPlan.index]
        : getUpdatedPlans[selectedPlan.index]; // Use getUpdatedPlans or getUpdatedPlansCharting

      const req = {
        User: username,
        Planname: planDetails.Planname || planDetails.PlanName, // Ensure correct plan name is passed
        CouponCode: couponCode,
      };

      const res = await applyCouponCode(req);

      if (res.Status) {
        const actualPrice = planDetails.SOPPrice || planDetails.ChartPerMonth;
        const discountPercentage = res.Data; // Discount percentage from the response
        const discountedPrice =
          actualPrice - (actualPrice * discountPercentage) / 100;

        setVerificationMessage("Verified");
        setVerificationColor("green");
        setIsContinueEnabled(true); // Enable the "Continue" button
        setSelectedPlan({
          ...selectedPlan,
          discountedPrice: discountedPrice.toFixed(2), // Store the discounted price
          discountPercentage, // Store the discount percentage
        });
      } else {
        setVerificationMessage("Not Applicable");
        setVerificationColor("red");
        setIsContinueEnabled(false); // Disable the "Continue" button
      }
    } else {
      console.error("No plan selected for verification.");
    }
  };

  const handleContinue = async () => {
    handleClose(); // Close the modal
    if (selectedPlan) {
      const actualPrice = selectedPlan.SOPPrice || selectedPlan.ChartPerMonth;
      const discountedPrice = selectedPlan.discountedPrice || actualPrice;
      const discountPercentage = selectedPlan.discountPercentage || 0;

      if (selectedPlan.isBuyNow) {
        // Show Confirm Purchase modal for Buy Now
        const result = await Swal.fire({
          title: "Confirm Purchase",
          html: `
            <p>Actual Price: <strong>₹${actualPrice}</strong></p>
            <p>Discount: <strong>${discountPercentage}%</strong></p>
            <p>After Discount: <strong>₹${discountedPrice}</strong></p>
          `,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          reverseButtons: false,
          showCloseButton: true, // Add close button to the top-right corner
          allowEnterKey: true, // Enable Enter key for confirmation
          focusConfirm: true, // Focus on the "Yes" button
        });

        if (result.isConfirmed) {
          HandleBuyPlan(
            selectedPlan.index,
            1,
            selectedPlan.isCharting,
            discountedPrice
          ); // Pass discounted price
        }
      } else {
        if (!selectedPlan.isCharting) {
          // SOP: Show both options
          const result = await Swal.fire({
            title: "Choose an Option",
            text: `Do you want to extend the end date or extend the number of scripts for the plan: ${
              selectedPlan.Planname || selectedPlan.PlanName
            }?`,
            icon: "question",
            // showCancelButton: true,
            confirmButtonText: "Extend End Date",
            // cancelButtonText: "Extend Number of Scripts",
            reverseButtons: false, // Ensure "Extend End Date" is on the left and "Extend Number of Scripts" is on the right
            allowOutsideClick: false, // Prevent closing the alert by clicking outside
            showCloseButton: true, // Add a close button to the top-right corner
            allowEnterKey: true, // Enable Enter key for confirmation
            focusConfirm: true, // Focus on the "Extend End Date" button
          });
          if (result.isConfirmed) {
            await HandleBuyPlan(
              selectedPlan.index,
              0,
              selectedPlan.isCharting,
              discountedPrice
            ); // Extend End Date
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            await HandleBuyPlan(
              selectedPlan.index,
              1,
              selectedPlan.isCharting,
              discountedPrice
            ); // Extend Number of Scripts
          }
        } else {
          // Charting: Only Extend End Date
          const result = await Swal.fire({
            title: "Extend End Date",
            text: `Do you want to extend the end date for the plan: ${
              selectedPlan.Planname || selectedPlan.PlanName
            }?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Extend End Date",
            cancelButtonText: "Cancel",
            reverseButtons: false,
            allowOutsideClick: false,
            showCloseButton: true,
            allowEnterKey: true,
            focusConfirm: true,
          });
          if (result.isConfirmed) {
            await HandleBuyPlan(
              selectedPlan.index,
              0,
              selectedPlan.isCharting,
              discountedPrice
            ); // Only Extend End Date
          }
        }
      }
    }
  };

  const handleContinueWithout = async () => {
    handleClose(); // Close the modal
    if (selectedPlan) {
      if (selectedPlan.isBuyNow) {
        // Show Confirm Purchase modal for Buy Now
        const result = await Swal.fire({
          title: "Confirm Purchase",
          text: `Do you want to continue with this plan: ${
            selectedPlan.Planname || selectedPlan.PlanName
          } for ₹${selectedPlan.SOPPrice || selectedPlan.ChartPerMonth}?`,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          confirmButtonColor: "#28a745", // Green
          cancelButtonColor: "#d33", // Red
          focusConfirm: true, // Focus on the "Yes" button
          allowEnterKey: true, // Enable Enter key for confirmation
        });

        if (result.isConfirmed) {
          HandleBuyPlan(selectedPlan?.index, 1, selectedPlan?.isCharting); // Confirm purchase
        }
      } else {
        if (!selectedPlan.isCharting) {
          const result = await Swal.fire({
            title: "Choose an Option",
            text: `Do you want to extend the end date or extend the number of scripts for the plan: ${
              selectedPlan.Planname || selectedPlan.PlanName
            }?`,
            icon: "question",
            showCancelButton: false,
            confirmButtonText: "Extend End Date",
            // cancelButtonText: "Extend Number of Scripts",
            reverseButtons: false, // Ensure "Extend End Date" is on the left and "Extend Number of Scripts" is on the right
            allowOutsideClick: false, // Prevent closing the alert by clicking outside
            showCloseButton: true, // Add a close button to the top-right corner
            allowEnterKey: true, // Enable Enter key for confirmation
            focusConfirm: true, // Focus on the "Extend End Date" button
          });
          if (result.isConfirmed) {
            await HandleBuyPlan(selectedPlan.index, 0, selectedPlan.isCharting); // Extend End Date
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            await HandleBuyPlan(selectedPlan.index, 1, selectedPlan.isCharting); // Extend Number of Scripts
          }
        } else {
          // Charting plan: Only allow Extend End Date
          const result = await Swal.fire({
            title: "Extend End Date",
            text: `Do you want to extend the end date for the plan: ${
              selectedPlan.Planname || selectedPlan.PlanName
            }?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Extend End Date",
            cancelButtonText: "Cancel",
            reverseButtons: false,
            allowOutsideClick: false,
            showCloseButton: true,
            allowEnterKey: true,
            focusConfirm: true,
          });
          if (result.isConfirmed) {
            await HandleBuyPlan(selectedPlan.index, 0, selectedPlan.isCharting); // Only Extend End Date
          }
        }
      }
    }
  };

  const handleBuyNow = (index, isCharting) => {
    const planDetails =
      value == 1
        ? plansData?.data[index]
        : value == 2
        ? plansData?.data[index]
        : plansData?.data[index];
    if (
      ![
        "Charting Three Days Live",
        "Three Days Live",
        "Two Days Demo",
        "One Week Demo",
      ].includes(planDetails?.Planname)
    ) {
      setSelectedPlan({ ...planDetails, index, isCharting, isBuyNow: true });
      handleOpen(); // Open the coupon modal
    } else {
      console.warn("Invalid plan selected:", planDetails.Planname);
    }
  };

  const handleBuyAgain = (index, isCharting) => {
    const planDetails = isCharting
      ? plansData?.data[index]
      : plansData?.data[index];
    if (
      ![
        "Charting Three Days Live",
        "Three Days Live",
        "Two Days Demo",
        "One Week Demo",
      ].includes(planDetails.Planname)
    ) {
      setSelectedPlan({ ...planDetails, index, isCharting, isBuyNow: false });
      handleOpen(); // Open the coupon modal
    } else {
      console.warn("Invalid plan selected:", planDetails.Planname);
    }
  };

  const handleCloseSOPModal = () => {
    setShowSOPModal(false);
    setSelectedSOPIndex(null);
  };

  const onSelectSOPPlan = async (plan, isAddon = false) => {
    let NumMultiplier = 1;
    if (plan["Plan Validity"] === "One_Month") {
      NumMultiplier = 1;
    } else if (plan["Plan Validity"] === "Half_Yearly") {
      NumMultiplier = 6;
    } else if (plan["Plan Validity"] === "Quarterly") {
      NumMultiplier = 3;
    }

    setSelectedSOPIndex(
      getUpdatedPlans.findIndex((p) => p.Planname === plan.Planname)
    );
    // Swal confirmation before processing
    await Swal.fire({
      title: `Confirm AddOn Purchase`,
      html: `<div style='text-align:center;  '>
        <b class='card-text-Color'>Plan Name:</b> <span class='card-text-Color'>${
          plan.Planname
        }</span><br/>
        <b class='card-text-Color'>Extension:</b> <span class='card-text-Color'>${
          selectedAddOnPlan?.Planname || ""
        }</span><br/>
        <b class='card-text-Color'>AddOn Price:</b> <span class='card-text-Color'>₹${
          (selectedAddOnPlan?.Price || 1) * NumMultiplier
        }</span>
      </div>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      focusConfirm: true,
      showCloseButton: true,
      allowEnterKey: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const req = {
            Username: username,
            dataid: plan._id,
            Extendtype: "",
          };

          if (!isAddon && (plan.SOPPrice || plan.ChartPerMonth) > userBalance) {
            return Swal.fire({
              title: "Insufficient Balance",
              text: "Please add funds to your account to proceed with the purchase.",
              icon: "warning",
              confirmButtonText: "ok",
              cancelButtonText: "Cancel",
              reverseButtons: true,
              showCloseButton: true,
            });
          }

          const buyPlanResponse = await BuyPlanNew(req);
          if (buyPlanResponse.Status) {
            const req1 = {
              Username: username,
              transactiontype: "Purchase",
              money: (selectedAddOnPlan?.Price || 1) * NumMultiplier,
              Activity: selectedAddOnPlan.Planname,
            };

            const CheckBalanceResponse = await AddBalance(req1);
            fetchPurchasedPlans();
            if (CheckBalanceResponse.Status) {
              Swal.fire({
                title: "Success!",
                text: buyPlanResponse.message,
                icon: "success",
                timer: 1500,
                timerProgressBar: true,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "Unable to update balance after plan purchase.",
                icon: "error",
                timer: 1500,
                timerProgressBar: true,
              });
            }
          } else {
            Swal.fire({
              title: "Error!",
              text: buyPlanResponse.message || "Unable to purchase plan",
              icon: "error",
              timer: 1500,
              timerProgressBar: true,
            });
          }
        } catch (error) {
          console.error("Error in transaction:", error);
          Swal.fire({
            title: "Error",
            text: "An unexpected error occurred",
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
        handleCloseSOPModal();
      } else {
        // Cancelled
        handleCloseSOPModal();
      }
    });
  };

  const toggleOptions = (index) => {
    setExpandedOptions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const toggleExpand = (index) => {
    setExpandedPatternItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const fetchPlans = async () => {
    try {
      const response = await AllUserPlanDetails({ userName: username });

      if (response.Status) {
        setPlansData({
          loading: false,
          data: response?.Data || [],
        });
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      setPlansData({
        loading: false,
        data: [],
      });
    }
  };

  const fetchAddOnPlans = async () => {
    try {
      const response = await getAddOnPlans();
      if (response.Status) {
        setAddOnPlans(response.Data);
        setPlansData((prevData) => ({
          ...prevData,
          addonPlans: response.Data,
        }));
      } else {
        console.error("Failed to fetch AddOn plans:", response.message);
      }
    } catch (error) {
      console.error("Error fetching AddOn plans:", error);
    }
  };

  const fetchPurchasedPlans = async () => {
    try {
      const response = await Get_All_Buyed_Plans({ userName: username });

      if (response.Status) {
        setPurchasedPlans(response.Allotplan || []);
      }
    } catch (error) {
      console.error("Error fetching purchased plans:", error);
    }
  };
  const isPlanExpired = async () => {
    try {
      const response = await ExpirePlanDetails(username);
      if (response.Status) {
        setPlanExpired(response.Admin.Planname || []);
      }
    } catch (error) {
      console.error("Error fetching purchased plans:", error);
    }
  };

  const isPlanPurchased = (planName) => {
    return purchasedPlans.some((plan) => plan.Planname === planName);
  };

  const HandleBuyPlan = async (index, type, isCharting, price) => {
    try {
      const planDetails =
        value == 1
          ? plansData?.data[index]
          : value == 2
          ? plansData?.data[index]
          : plansData?.data[index];

      if (true) {
        const req = {
          Username: username,
          dataid: planDetails._id,
          Extendtype: "",
        };

        if ((planDetails.SOPPrice || planDetails.ChartPerMonth) > userBalance) {
          return Swal.fire({
            title: "Insufficient Balance",
            text: "Please add funds to your account to proceed with the purchase.",
            icon: "warning",
            confirmButtonText: "ok",
            cancelButtonText: "Cancel",
            reverseButtons: true,
            showCloseButton: true,
          });
        }

        const buyPlanResponse = await BuyPlanNew(req);
        if (buyPlanResponse.Status) {
          const req1 = {
            Username: username,
            transactiontype: "Purchase",
            money: price || planDetails.SOPPrice || planDetails.ChartPerMonth,
            Activity: planDetails?.Planname, // Use discounted price if available
          };

          const CheckBalanceResponse = await AddBalance(req1);

          fetchPurchasedPlans();

          if (CheckBalanceResponse.Status) {
            Swal.fire({
              title: "Success!",
              text: buyPlanResponse.message,
              icon: "success",
              timer: 1500,
              timerProgressBar: true,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Unable to update balance after plan purchase.",
              icon: "error",
              timer: 1500,
              timerProgressBar: true,
            });
          }
        } else {
          Swal.fire({
            title: "Error!",
            text: buyPlanResponse.message,
            icon: "error",
            timer: 1500,
            timerProgressBar: true,
          });
        }
      } else {
        Swal.fire({
          title: "Error!",
          text: "Unabe to purchase plan",
          icon: "warning",
          timer: 1500,
          timerProgressBar: true,
        });
      }
    } catch (error) {
      console.error("Error in transaction:", error);
      Swal.fire({
        title: "Error",
        text: "An unexpected error occurred",
        icon: "error",
        timer: 1500,
        timerProgressBar: true,
      });
    }
  };

  const getUpdatedPlans = plansData.data?.filter(
    (plan) =>
      plan?.SOPPrice !== 0 &&
      plan?.payment !== 0 &&
      plan.Planname !== "Three Days Live" &&
      plan.Planname !== "Two Days Demo" &&
      plan.Planname !== "One Week Demo"
  );

  const getUpdatedPlansCharting = plansData.data?.filter(
    (plan) =>
      plan?.ChartPerMonth !== 0 &&
      plan.Planname !== "Charting Three Days Live" &&
      plan.Planname !== "Three Days Live" &&
      plan.Planname !== "Two Days Demo" &&
      plan.Planname !== "One Week Demo"
  );

  const fetchBalance = async () => {
    try {
      const response = await GetUserBalence({ userName: username });
      if (response.Status) {
        const balance = response.Balance || 0;
        setUserBalance(balance);
      }
    } catch (error) {
      console.error("Error fetching user balance:", error);
    }
  };

  const hasPurchasedSOP =
    getUpdatedPlans &&
    getUpdatedPlans.some(
      (plan) =>
        isPlanPurchased(plan.Planname) && !planExpired?.includes(plan.Planname)
    );

  const handleBuyNowAddon = (index) => {
    setShowSOPModal(true);
    setSelectedAddOnPlan(plansData.addonPlans[index]); // Save selected AddOn plan
  };

  return (
    <Content
      Page_title={"📌 All Plans"}
      button_status={false}
      backbutton_status={false}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item active " aria-current="page">
            Plans
          </li>
        </ol>
      </nav>
      <div className="">
        {expire?.includes(1) ? (
          <div className="col-lg-9">
            <NewsTicker />
          </div>
        ) : (
          ""
        )}
      </div>
      <ul className="nav nav-tabs mb-5">
        {!adminPermission?.includes("OverallPlan") && (
          <li className="nav-item">
            <a
              className={value === "1" ? "active nav-link" : "nav-link"}
              onClick={() => setValue("1")}
            >
              SOP
            </a>
          </li>
        )}
        {!adminPermission?.includes("OverallPlan") && (
          <li className="nav-item">
            <a
              className={value === "2" ? "active nav-link" : "nav-link"}
              onClick={() => setValue("2")}
            >
              Charting
            </a>
          </li>
        )}
        {!adminPermission?.includes("OverallPlan") && hasPurchasedSOP && (
          <li className="nav-item">
            <a
              className={value === "4" ? "active nav-link" : "nav-link"}
              onClick={() => setValue("4")}
            >
              AddOn
            </a>
          </li>
        )}
      </ul>

      <Box sx={{ width: "100%", typography: "body1" }}>
        {value === "1" && (
          <div className="">
            {plansData.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  minHeight: "200px",
                }}
              >
                <Loader />
              </div>
            ) : plansData && plansData.data.length > 0 ? (
              <div className="allplans-container row g-4">
                {plansData.data.map(
                  (plan, index) =>
                    plan.UserPlantype == "SOPPlan" && (
                      <>
                        {plan.GoldenStrategy.length > 0 &&
                        !getData?.profile?.Permission?.includes(
                          "Golden Strategy"
                        ) ? (
                          ""
                        ) : ( <div
                        key={index}
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                      >
                          <div className="allplan-card h-100">
                            {/* --- Header --- */}
                            <div className="price d-flex align-items-center justify-content-between">
                              <h2 className="plan-title mb-0">
                                {plan.Planname}
                              </h2>
                              <div className="text-end">
                                <FaRupeeSign
                                  className="text-success"
                                  style={{
                                    width: "10px",
                                    marginRight: "4px",
                                  }}
                                />
                                <span className="card-text-Color fs-6">
                                  {plan.SOPPrice || plan.payment || 0}
                                </span>
                              </div>
                            </div>

                            <hr className="card-text-Color" />

                            {/* --- Features --- */}
                            <ul className="features">
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Duration:
                                </strong>
                                <span>{plan["Plan Validity"]}</span>
                              </li>

                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Scripts:
                                </strong>
                                <span>{plan.NumberofScript}</span>
                              </li>

                              {plan?.Scalping?.length > 0 && (
                                <li className="d-flex justify-content-between align-items-center">
                                  <strong className="card-text-Color">
                                    Scalping:
                                  </strong>
                                  <span>{plan.Scalping.join(", ")}</span>
                                </li>
                              )}

                              {/* --- Option Strategy --- */}
                              {plan["Option Strategy"]?.length > 0 && (
                                <li className="d-flex justify-content-between align-items-center">
                                  <strong className="card-text-Color">
                                    Options:
                                  </strong>
                                  <span className="text-end">
                                    {plan["Option Strategy"].length > 1 ? (
                                      expandedOptions.includes(index) ? (
                                        <>
                                          {plan["Option Strategy"].join(", ")}
                                          <span
                                            className="show-more ms-2"
                                            onClick={() => toggleOptions(index)}
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                          >
                                            🔼
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          {plan["Option Strategy"][0]}
                                          <span
                                            className="show-more ms-2"
                                            onClick={() => toggleOptions(index)}
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                          >
                                            🔽
                                          </span>
                                        </>
                                      )
                                    ) : (
                                      plan["Option Strategy"].join(", ")
                                    )}
                                  </span>
                                </li>
                              )}

                              {/* --- Patterns --- */}
                              {plan.Pattern?.length > 0 && (
                                <li className="d-flex justify-content-between align-items-center">
                                  <strong className="card-text-Color">
                                    Patterns:
                                  </strong>
                                  <span className="text-end">
                                    {plan.Pattern.length > 1 ? (
                                      expandedPatternItems.includes(index) ? (
                                        <>
                                          {plan.Pattern.join(", ")}
                                          <span
                                            className="show-more ms-2"
                                            onClick={() => toggleExpand(index)}
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                          >
                                            🔼
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          {plan.Pattern[0]}
                                          <span
                                            className="show-more ms-2"
                                            onClick={() => toggleExpand(index)}
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                          >
                                            🔽
                                          </span>
                                        </>
                                      )
                                    ) : (
                                      plan.Pattern[0]
                                    )}
                                  </span>
                                </li>
                              )}

                              {/* --- Golden Strategy --- */}
                              {plan.GoldenStrategy?.length > 0 &&
                                getData?.profile?.Permission?.includes(
                                  "Golden Strategy"
                                ) && (
                                  <li className="d-flex justify-content-between align-items-center">
                                    <strong className="card-text-Color">
                                      Golden Strategy:
                                    </strong>
                                    <span className="text-end">
                                      {plan.GoldenStrategy.length > 1 ? (
                                        expandedPatternItems.includes(index) ? (
                                          <>
                                            {plan.GoldenStrategy.join(", ")}
                                            <span
                                              className="show-more ms-2"
                                              onClick={() =>
                                                toggleExpand(index)
                                              }
                                              role="button"
                                              style={{ cursor: "pointer" }}
                                            >
                                              🔼
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            {plan.GoldenStrategy[0]}
                                            <span
                                              className="show-more ms-2"
                                              onClick={() =>
                                                toggleExpand(index)
                                              }
                                              role="button"
                                              style={{ cursor: "pointer" }}
                                            >
                                              🔽
                                            </span>
                                          </>
                                        )
                                      ) : (
                                        plan.GoldenStrategy[0]
                                      )}
                                    </span>
                                  </li>
                                )}

                              {plan?.SOPPaperTrade > 0 && (
                                <li className="d-flex justify-content-between align-items-center">
                                  <strong className="card-text-Color">
                                    Paper Trade:
                                  </strong>
                                  <span className="text-success">
                                    ₹{plan.SOPPaperTrade}
                                  </span>
                                </li>
                              )}

                              {plan?.SOPLiveTrade > 0 && (
                                <li className="d-flex justify-content-between align-items-center">
                                  <strong className="card-text-Color">
                                    Live Trade:
                                  </strong>
                                  <span className="text-primary">
                                    ₹{plan.SOPLiveTrade}
                                  </span>
                                </li>
                              )}
                            </ul>

                            {/* --- Button --- */}
                            {plan.UserPlan ? (
                              <button
                                className="plan-btn buy-again"
                                onClick={() => handleBuyAgain(index, false)}
                              >
                                <Repeat2 size={18} className="me-2" /> Buy Again
                              </button>
                            ) : (
                              <button
                                className="plan-btn"
                                onClick={() => handleBuyNow(index, false)}
                              >
                                <ShoppingCart size={18} className="me-2" /> Buy
                                Now
                              </button>
                            )}
                          </div>
                      </div>

                        )}
                      </>
                    )
                )}
              </div>
            ) : (
              <div className="center-nodata">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/images/no-record-found.png"
                    width="50%"
                    alt="No records found"
                  />
                </div>
              </div>
            )}
          </div>
        )}
        {value === "2" && (
          <div className="allplans-container">
            {plansData.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  minHeight: "200px",
                }}
              >
                <Loader />
              </div>
            ) : plansData && plansData.data.length > 0 ? (
              <div className="allplans-container row g-4">
                {plansData.data.map(
                  (plan, index) =>
                    plan.UserPlantype == "ChartingPlan" && (
                      <div
                        key={index}
                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                      >
                        <div className="allplan-card h-100 d-flex flex-column justify-content-between">
                          {/* Header */}
                          <div className="price d-flex align-items-center justify-content-between">
                            <h2 className="plan-title mb-0">{plan.Planname}</h2>
                            <div className="text-end">
                              <FaRupeeSign
                                className="text-success"
                                style={{ width: "10px", marginRight: "4px" }}
                              />
                              <span className="card-text-Color fs-6 ps-1">
                                {plan.ChartPerMonth || 0}
                              </span>
                            </div>
                          </div>

                          <hr className="card-text-Color" />

                          {/* Features */}
                          <ul className="features flex-grow-1">
                            <li className="d-flex justify-content-between align-items-center">
                              <strong className="card-text-Color">
                                Duration:
                              </strong>
                              <h6 className="mb-0">{plan["Plan Validity"]}</h6>
                            </li>

                            {plan.ChartingSignal && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Charting Signals:
                                </strong>
                                <h6 className="mb-0">
                                  {plan.ChartingSignal.join(", ")}
                                </h6>
                              </li>
                            )}

                            {plan.ChartLiveTrade !== 0 && (
                              <li className="d-flex justify-content-between align-items-center">
                                <span className="d-flex align-items-center gap-2">
                                  <BadgePercent size={18} />
                                  <strong className="card-text-Color">
                                    Live Trade Price:
                                  </strong>
                                </span>
                                <h6 className="mb-0 text-primary">
                                  ₹{plan.ChartLiveTrade}
                                </h6>
                              </li>
                            )}

                            {plan.ChartPaperTrade !== 0 && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Paper Trade Price:
                                </strong>
                                <h6 className="mb-0 text-success">
                                  ₹{plan.ChartPaperTrade}
                                </h6>
                              </li>
                            )}

                            {plan.Strategytag && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Strategy Tag:
                                </strong>
                                <h6 className="mb-0">
                                  {Array.isArray(plan.Strategytag)
                                    ? plan.Strategytag.join(", ")
                                    : plan.Strategytag}
                                </h6>
                              </li>
                            )}
                          </ul>

                          {/* Action Button */}
                          {plan.UserPlan ? (
                            <button
                              className="plan-btn buy-again d-flex justify-content-center align-items-center gap-2 mt-3"
                              onClick={() => handleBuyAgain(index, true)}
                            >
                              <Repeat2 size={18} /> Buy Again
                            </button>
                          ) : (
                            <button
                              className="plan-btn d-flex justify-content-center align-items-center gap-2 mt-3"
                              onClick={() => handleBuyNow(index, true)}
                            >
                              <ShoppingCart size={18} /> Buy Now
                            </button>
                          )}
                        </div>
                      </div>
                    )
                )}
              </div>
            ) : (
              <div className="center-nodata">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/images/no-record-found.png"
                    width="50%"
                    alt="No records found"
                  />
                </div>
              </div>
            )}
          </div>
        )}
        {value === "3" && (
          <div className="">
            {plansData.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  minHeight: "200px",
                }}
              >
                <Loader />
              </div>
            ) : plansData && plansData.data.length > 0 ? (
              <div className="allplans-container row g-4">
                {plansData.data.map(
                  (plan, index) =>
                    plan.UserPlantype === "OverallPlan" && (
                      <div
                        key={index}
                        className="col-xl-4 col-lg-4 col-md-6 col-sm-12"
                      >
                        <div className="allplan-card h-100">
                          {/* ---- PRICE HEADER ---- */}
                          <div className="price text-center">
                            <h2 className="plan-title">{plan.Planname}</h2>
                            <div className="d-flex justify-content-center align-items-center gap-1">
                              <FaRupeeSign className="text-success" />
                              <span className="card-text-Color fs-5 fw-bold">
                                {plan.OverallPrice || plan.payment || 0}
                              </span>
                            </div>
                            <hr />
                          </div>

                          {/* ---- PLAN DETAILS ---- */}
                          <ul className="features">
                            <li className="d-flex justify-content-between align-items-center">
                              <strong className="card-text-Color">
                                Duration:
                              </strong>
                              <span>{plan["Plan Validity"]}</span>
                            </li>

                            <li className="d-flex justify-content-between align-items-center">
                              <strong className="card-text-Color">
                                Scripts:
                              </strong>
                              <span>{plan.NumberofScript}</span>
                            </li>

                            {plan?.Scalping?.length > 0 && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Scalping:
                                </strong>
                                <span>{plan.Scalping.join(", ")}</span>
                              </li>
                            )}

                            {/* ---- Option Strategy ---- */}
                            {plan["Option Strategy"] &&
                              plan["Option Strategy"].length > 0 && (
                                <li className="d-flex justify-content-between align-items-center">
                                  <span className="d-flex align-items-center gap-2">
                                    <FileText size={18} />{" "}
                                    <strong className="card-text-Color">
                                      Options:
                                    </strong>
                                  </span>
                                  <span className="text-end w-50">
                                    {plan["Option Strategy"].length > 1 ? (
                                      expandedOptions.includes(index) ? (
                                        <>
                                          {plan["Option Strategy"].join(", ")}
                                          <span
                                            className="show-more ms-2"
                                            onClick={() => toggleOptions(index)}
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                          >
                                            🔼
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          {plan["Option Strategy"][0]}
                                          <span
                                            className="show-more ms-2"
                                            onClick={() => toggleOptions(index)}
                                            role="button"
                                            style={{ cursor: "pointer" }}
                                          >
                                            🔽
                                          </span>
                                        </>
                                      )
                                    ) : (
                                      plan["Option Strategy"].join(", ")
                                    )}
                                  </span>
                                </li>
                              )}

                            {/* ---- Pattern ---- */}
                            {plan.Pattern && plan.Pattern.length > 0 && (
                              <li className="d-flex justify-content-between align-items-center">
                                <span className="d-flex align-items-center gap-2">
                                  <LineChart size={18} />{" "}
                                  <strong className="card-text-Color">
                                    Patterns:
                                  </strong>
                                </span>
                                {plan.Pattern?.length > 1 ? (
                                  <span className="text-end w-50">
                                    {expandedPatternItems.includes(index) ? (
                                      <>
                                        {plan.Pattern.join(", ")}
                                        <span
                                          className="show-more ms-2"
                                          onClick={() => toggleExpand(index)}
                                          role="button"
                                          style={{ cursor: "pointer" }}
                                        >
                                          🔼
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        {plan.Pattern[0]}
                                        <span
                                          className="show-more ms-2"
                                          onClick={() => toggleExpand(index)}
                                          role="button"
                                          style={{ cursor: "pointer" }}
                                        >
                                          🔽
                                        </span>
                                      </>
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-end">
                                    {plan.Pattern[0]}
                                  </span>
                                )}
                              </li>
                            )}

                            {/* ---- Charting ---- */}
                            {plan.ChartingSignal && (
                              <li className="d-flex justify-content-between align-items-center">
                                <span className="d-flex align-items-center gap-2">
                                  <Signal size={18} />
                                  <strong className="card-text-Color">
                                    Charting :
                                  </strong>
                                </span>
                                {plan.ChartingSignal.length === 1 ? (
                                  <h6 className="mb-0">
                                    {plan.ChartingSignal[0]}
                                  </h6>
                                ) : (
                                  <select className="form-select w-50">
                                    {plan.ChartingSignal.map((signal, i) => (
                                      <option key={i} value={signal}>
                                        {signal}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </li>
                            )}

                            {/* ---- Strategy Tag ---- */}
                            {plan.Strategytag && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Strategy Tag:
                                </strong>
                                <h6 className="mb-0">
                                  {Array.isArray(plan.Strategytag) ? (
                                    <select className="form-select">
                                      {plan.Strategytag.map((tag, i) => (
                                        <option key={i} value={tag}>
                                          {tag}
                                        </option>
                                      ))}
                                    </select>
                                  ) : (
                                    plan.Strategytag
                                  )}
                                </h6>
                              </li>
                            )}

                            {plan?.SOPPaperTrade > 0 && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Paper Trade:
                                </strong>
                                <span className="text-success">
                                  ₹{plan.SOPPaperTrade}
                                </span>
                              </li>
                            )}

                            {plan?.SOPLiveTrade > 0 && (
                              <li className="d-flex justify-content-between align-items-center">
                                <strong className="card-text-Color">
                                  Live Trade:
                                </strong>
                                <span className="text-primary">
                                  ₹{plan.SOPLiveTrade}
                                </span>
                              </li>
                            )}
                          </ul>

                          {/* ---- BUTTON ---- */}
                          {plan.UserPlan ? (
                            <button
                              className="plan-btn buy-again"
                              onClick={() => handleBuyAgain(index, false)}
                            >
                              <Repeat2 size={18} className="me-2" /> Buy Again
                            </button>
                          ) : (
                            <button
                              className="plan-btn"
                              onClick={() => handleBuyNow(index, false)}
                            >
                              <ShoppingCart size={18} className="me-2" /> Buy
                              Now
                            </button>
                          )}
                        </div>
                      </div>
                    )
                )}
              </div>
            ) : (
              <div className="center-nodata">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/images/no-record-found.png"
                    width="50%"
                    alt="No records found"
                  />
                </div>
              </div>
            )}
          </div>
        )}

        {value === "4" && hasPurchasedSOP && (
          <div className="allplans-container">
            {plansData.loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  minHeight: "200px",
                }}
              >
                <Loader />
              </div>
            ) : plansData.addonPlans && plansData.addonPlans.length > 0 ? (
              <div className="allplans-container row g-4">
                {plansData.addonPlans.map((plan, index) => (
                  <div
                    key={index}
                    className="col-xl-3 col-lg-4 col-md-6 col-sm-12"
                  >
                    <div className="allplan-card h-100 d-flex flex-column justify-content-between">
                      {/* Header */}
                      <div className="price d-flex align-items-center justify-content-between">
                        <h2 className="plan-title mb-0">{plan.Planname}</h2>
                        <div className="text-end">
                          <FaRupeeSign
                            className="text-success"
                            style={{ width: "10px", marginRight: "4px" }}
                          />
                          <span className="card-text-Color fs-6 ps-1">
                            {plan.Price || 0}
                          </span>
                        </div>
                      </div>

                      <hr className="card-text-Color" />

                      {/* Features */}
                      <ul className="features flex-grow-1">
                        <li className="d-flex align-items-center gap-2">
                          <CalendarDays size={18} />
                          <strong className="card-text-Color">Duration:</strong>
                          <span className="text-end ms-auto">One Time</span>
                        </li>
                        <li className="d-flex align-items-center gap-2">
                          <Layers3 size={18} />
                          <strong className="card-text-Color">
                            Number of Scripts:
                          </strong>
                          <span className="text-end ms-auto">
                            {plan.NumberofScript}
                          </span>
                        </li>
                        {/* Add more addon plan details here */}
                      </ul>

                      {/* Action Button */}
                      <button
                        type="button"
                        className="plan-btn d-flex justify-content-center align-items-center gap-2 mt-3"
                        onClick={() => handleBuyNowAddon(index, false)}
                      >
                        <ShoppingCart size={18} /> Buy Now
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="center-nodata">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/images/no-record-found.png"
                    width="50%"
                    alt="No records found"
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="coupon-modal-title"
        aria-describedby="coupon-modal-description"
        className="coupon-modal"
      >
        <Box sx={style}>
          <div className="p-4 plan-modal shadow">
            {/* Close Button */}
            <Button
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 5,
                right: 8,
                minWidth: "auto",
                padding: 1,
                color: "#000",
                backgroundColor: "transparent",
                "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.1)" },
                transition: "background-color 0.3s ease",
              }}
            >
              ✖
            </Button>
            <Typography
              id="coupon-modal-title"
              variant="h6"
              component="h2"
              gutterBottom
            >
              Enter Coupon Code
            </Typography>

            {/* Input + Verify Button */}
            <Stack direction="row" spacing={2} alignItems="center" mb={1}>
              <TextField
                fullWidth
                label="Coupon Code"
                value={couponCode}
                onChange={(e) => {
                  setCouponCode(e.target.value);
                  setVerificationMessage("");
                  setIsContinueEnabled(false);
                }}
              />
              <Button variant="outlined" onClick={handleVerify}>
                Verify
              </Button>
            </Stack>

            {/* Verification Message */}
            {verificationMessage && (
              <Typography
                variant="body2"
                sx={{ color: verificationColor, marginTop: "8px" }}
              >
                {verificationMessage}
              </Typography>
            )}

            {/* Continue Button (Dynamic) */}
            <Stack direction="column" spacing={2} mt={3}>
              {verificationMessage === "Verified" && isContinueEnabled ? (
                <button
                  variant="contained"
                  className="allplan-button buy-again"
                  onClick={handleContinue}
                  disabled={!isContinueEnabled}
                  disableRipple={!isContinueEnabled}
                >
                  Continue
                </button>
              ) : (
                <button
                  variant="text"
                  className="addbtn btn border "
                  onClick={handleContinueWithout}
                >
                  Continue without Coupon
                </button>
              )}
            </Stack>
          </div>
        </Box>
      </Modal>

      <Modal open={showSOPModal} onClose={handleCloseSOPModal}>
        <Box
          sx={{
            ...style,
            width: 500,
            bgcolor: "#fff",
            borderRadius: 2,
            p: 3,
            boxShadow: 24,
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ mb: 2, color: "#333", fontWeight: 600 }}
          >
            Select SOP Plan (Already Purchased)
          </Typography>

          <div
            style={{
              maxHeight: 350,
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {getUpdatedPlans && getUpdatedPlans.length > 0 ? (
              getUpdatedPlans
                .filter(
                  (plan) =>
                    isPlanPurchased(plan.Planname) &&
                    !planExpired?.includes(plan.Planname)
                )
                .map((plan, idx) => (
                  <div
                    key={idx}
                    onClick={async () => {
                      setSelectedSOPIndex(idx);
                      handleCloseSOPModal();
                      setTimeout(() => onSelectSOPPlan(plan, true), 200);
                    }}
                    className={`card-sop-select card-bg-color${
                      selectedSOPIndex === idx ? " selected-card" : ""
                    }`}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      backgroundColor:
                        selectedSOPIndex === idx ? "#e0f7fa" : "#f8f9fa",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#e3f2fd")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor =
                        selectedSOPIndex === idx ? "#e0f7fa" : "#f8f9fa")
                    }
                  >
                    <span>
                      <strong>{plan.Planname}</strong> | {plan["Plan Validity"]}{" "}
                      | ₹{plan.SOPPrice || plan.payment} | Scripts:{" "}
                      {plan.NumberofScript}
                    </span>
                  </div>
                ))
            ) : (
              <Typography sx={{ color: "#555", textAlign: "center", mt: 2 }}>
                No purchased SOP plans found.
              </Typography>
            )}
          </div>

          <button
            className="addbtn btn"
            onClick={handleCloseSOPModal}
            style={{
              marginTop: "16px",
              width: "100%",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              padding: "10px",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: 600,
              transition: "0.3s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#0056d2")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#007bff")
            }
          >
            Close
          </button>
        </Box>
      </Modal>
    </Content>
  );
};

export default ServicesList;
